import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    tiposPresupuestos: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    nombre: '',
    incluirInactivos: false,

    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.tiposPresupuestos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.incluirInactivos = false;
    },

    'INICIALIZAR'(state) {
        state.tiposPresupuestos = [];
    },
    'SET_TIPOS_PRESUPUESTOS'(state, tiposPresupuestos) {
        state.tiposPresupuestos = tiposPresupuestos;
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, list) {
        state.list = list;
        state.selectList = list.map(item => item.nombre.trim());
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },

    getTiposPresupuestos: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            var queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if (state.nombre != '') {
                queryString += '&nombre=' + state.nombre;
            }
            if ((/true/i).test(state.incluirInactivos)) {
                queryString += '&incluirInactivos= true';
            }

            apiAxios.get('tipos-presupuestos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }
                    commit('SET_TIPOS_PRESUPUESTOS', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getList: ( { commit } ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('tipos-presupuestos/list')
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}